import { Box, Button, FormikField as Field, Input } from '@betterment/samba-react';
import { Form, Formik } from 'formik';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import * as Yup from 'yup';

import { JOINT_ACCOUNT_FLOW_CONFIG, useJointAccountStep } from './JointAccountFlow';

import { WorkflowLayout } from '../../../../Shared/layout/WorkflowLayout';

type FormValues = Yup.InferType<(typeof JOINT_ACCOUNT_FLOW_CONFIG)['user_search']['schema']>;

export const UserSearch: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { flowId } = useParams<{ flowId: string }>();
  const navigate = useNavigate();

  const returnTo = searchParams.get('returnTo');

  const { values, commit } = useJointAccountStep('user_search');

  const initialValues: FormValues = {
    email: values?.email || '',
    ssn: values?.ssn || '',
  };

  const handleSubmit = (formValues: FormValues) => {
    commit(formValues);

    void navigate(`/add_account/self_directed_investing/joint_taxable/${flowId}/user_details`);
  };

  return (
    <WorkflowLayout
      pageTitle="User search"
      workflowTitle=""
      onBack={() => navigate(-1)}
      onClose={() => (returnTo ? navigate(returnTo) : navigate('/'))}
      size="small"
    >
      <Box
        css={{
          display: 'grid',
          gap: 'space.200',
        }}
      >
        <h1>Who is the secondary account holder?</h1>
        <Formik
          onSubmit={handleSubmit}
          initialValues={initialValues}
          validationSchema={JOINT_ACCOUNT_FLOW_CONFIG.user_search.schema}
          validateOnChange={false}
          validateOnBlur={false}
          enableReinitialize={true}
        >
          <Form>
            <Box css={{ display: 'grid', gap: 'space.200', maxWidth: '400px' }}>
              <Field name="email">
                <Field.Label>Email</Field.Label>
                <Field.Control>
                  <Input />
                </Field.Control>
                <Field.ErrorMessage />
              </Field>
              <Field name="ssn">
                <Field.Label>SSN</Field.Label>
                <Field.Control>
                  <Input />
                </Field.Control>
                <Field.ErrorMessage />
              </Field>

              <Box css={{ display: 'flex', gap: 'space.200' }}>
                <Button type="submit" variant="solidPrimary" css={{ width: 'fit-content' }}>
                  Next
                </Button>
              </Box>
            </Box>
          </Form>
        </Formik>
      </Box>
    </WorkflowLayout>
  );
};
